import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { SidebarProvider } from "./contexts/SidebarContext";
import { SubscriptionProvider } from "./contexts/SubscriptionContext";
import { TourProvider } from "./contexts/TourContext";
import { DemoProvider } from "./contexts/DemoContext";

function App() {
  return (
    <AuthProvider>
      <SubscriptionProvider>
        <TourProvider>
          <DemoProvider>
            <SidebarProvider>
              <Routes />
            </SidebarProvider>
          </DemoProvider>
        </TourProvider>
      </SubscriptionProvider>
    </AuthProvider>
  );
}

export default App;
